import React, { useState, useEffect } from "react";
import MyNavbar from "../../../components/general/mynavbar/MyNavbar";
import MyHeroSection from "../../../subscreens/customer/home/herosection/MyHeroSection";
import Categoriess from "../../../subscreens/customer/home/categoriess/Categoriess";
import NewArrivals from "../../../subscreens/customer/home/newArrivals/NewArrivals";
import SellerBanner from "../../../subscreens/customer/home/sellerbanner/Sellerbanner";
import BestCards from "../../../subscreens/customer/home/bestCards/BestCards";
import Salebanner from "../../../subscreens/customer/home/Salebanner/SaleBanner";
import Features from "../../../subscreens/customer/home/features/Features";
import Footer from "../../../components/general/footer/Footer";
import useScrollToTop from "../../../contexts/UseScrolltoTop";
import BlogsSection from "../../../subscreens/customer/home/blogsection/BlogSection";
import HomeMarquee from "../../../components/general/marquee/Marquee";
// import AIFloatingButton from "../../../components/general/aiFloatingButton/AiFloatingButton";
import LoadingScreen from '../../../components/general/animations/Animations.js';

const Home = () => {
  useScrollToTop();
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setLoading(false);
  //   }, 2500);
  //   return () => clearTimeout(timer);
  // }, []);

  // if (loading) {
  //   return <LoadingScreen />;
  // }

  return (
    <>
      <HomeMarquee />
      <MyNavbar />
      <MyHeroSection />
      <Categoriess />
      <NewArrivals />
      <SellerBanner />
      <BestCards />
      <Features />
      <Salebanner />
      <BlogsSection />
      <Footer />
      {/* <AIFloatingButton /> */}
    </>
  );
};

export default Home;